export default __webpack_public_path__ + "static/media/core_01.f2ad3cf5.png";